import { render, staticRenderFns } from "./MarketplaceTemplateCarousel.vue?vue&type=template&id=363e60cb&"
import script from "./MarketplaceTemplateCarousel.vue?vue&type=script&lang=js&"
export * from "./MarketplaceTemplateCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports